import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isValidSeverity } from '../../../../shared/organizationPackages/filters';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import type { AnyFilter } from '../../../../shared/organizationPackages/filters';
import type { SelectOption } from '../../../types';

const SEVERITY_OPTIONS: SelectOption[] = [
  { value: 'critical', label: 'Critical (9-10)' },
  { value: 'high', label: 'High (7-8.9)' },
  { value: 'medium', label: 'Medium (4-6.9)' },
  { value: 'low', label: 'Low (0.1-3.9)' },
  { value: 'unknown', label: 'Unknown' },
];

type Props = {
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersVulnSeverity displays checkboxes which can be used to
 * filter packages by those that have vulns of specific severities.
 */
const PackageInventoryFiltersVulnSeverity: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const severities = useSelector(PackageInventoryStore.selectors.getFiltersVulnSeverities);

  // map current severities to SelectOption format
  const selectedCheckboxes = severities.map((severity: string) => ({
    label: SEVERITY_OPTIONS.find(option => option.value === severity)?.label || severity,
    value: severity,
  }));

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    const selectedSeverities = newSelected.map(({ value }) => value).filter(isValidSeverity);
    setFilters({ severities: selectedSeverities });
  };

  return (
    <FilterCardCheckboxes
      label="Severity"
      options={SEVERITY_OPTIONS}
      values={selectedCheckboxes}
      onChange={onChange}
      testId="package-inventory-filters-vuln--severity"
    />
  );
};

export default PackageInventoryFiltersVulnSeverity;
